// Base del API de Huésped+; HttpService la usa para no mandarle el token.
export const trimTrailingSlashes = value => (value || "").replace(/\/+$/, "");

export const getGuestAppApiBase = () =>
  trimTrailingSlashes(process.env.REACT_APP_GUEST_APP_API);

export const isGuestAppUrl = url => {
  const base = getGuestAppApiBase();
  if (!base || typeof url !== "string") return false;
  return url === base || url.indexOf(base + "/") === 0;
};
